// extracted by mini-css-extract-plugin
export default {"floatingIcon":"floatingIcon_floatingIcon__TwHNH","icon":"floatingIcon_icon__WaQ0J"};